import { render, staticRenderFns } from "./ChartLegendIcon.vue?vue&type=template&id=9122317e&"
import script from "./ChartLegendIcon.vue?vue&type=script&lang=js&"
export * from "./ChartLegendIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports